import React from "react";
import styles from "./DeliveryCard.module.scss";
import Text from "@components/atoms/Text";
import Image from "next/image";
import assetLoader from "@utils/internalImageLoder";
import { EventType, trackEventWithCommonProps } from "@utils/eventTracker";
import { getSelectedCityClient } from "@helpers/client/getSelectedCity";
import { addCaptureIntentIfNeeded, getLoginUrl } from "@utils/getLoginUrl";
import { PageType } from "@constants/pageTypes";

interface IDeliveryCardProps {
  expressDelivery?: boolean;
  deliveryDate: string;
  isLoggedIn: boolean;
  pageType?: string;
  brandName?: string;
  modelName?: string;
  variantName?: string;
  carAvailability?: string;
}

export default function DeliveryCard({
  expressDelivery = false,
  deliveryDate,
  isLoggedIn,
  pageType,
  brandName,
  modelName,
  variantName,
  carAvailability,
}: IDeliveryCardProps) {
  const { name: cityName } = getSelectedCityClient();

  const handleDeliveryClick = async () => {
    await trackEventWithCommonProps("action", EventType.TRACK_EVENT, {
      pageType: pageType || "",
      additionalProps: {
        action_type: "tap_btn",
        action_name: "tap_btn_login_for_delivery",
        section: "Variant",
        variant_name: variantName || "",
        car_availability: carAvailability || "",
        vehicle_make: brandName || "",
        vehicle_model: modelName || "",
        city_name: cityName || "",
      },
    });
    const mmvDetails = {
      make: brandName,
      model: modelName,
      variant: variantName || "",
      color: "",
    };
    if (typeof window !== "undefined") {
      sessionStorage.setItem("loginType", "Reveal delivery");
      localStorage.setItem(
        "MMV",
        JSON.stringify({
          make: brandName,
          model: modelName,
          variant: variantName || "",
        })
      );
    }
    window.location.href = getLoginUrl(
      addCaptureIntentIfNeeded(
        window.location.href,
        mmvDetails,
        "Reveal delivery",
        pageType as PageType
      )
    );
  };

  return (
    <div className={styles.deliveryBox}>
      <div className={styles.deliveryDateWrapper}>
        {expressDelivery && isLoggedIn ? (
          <Text level="p" className={styles.expressDeliveryLabel}>
            <Image
              src={`${assetLoader()}/icons/delivery-icon.svg`}
              alt="delivery-icon"
              width={20}
              height={20}
              loading="lazy"
              className={styles.deliveryIcon}
            />
            Express delivery by
          </Text>
        ) : (
          <Text level="p" className={styles.deliveryLabel}>
            Standard delivery by
          </Text>
        )}
        <Text level="p" className={styles.deliveryDate}>
          {deliveryDate}
        </Text>
      </div>
      {!isLoggedIn && (
        <div
          className={styles.deliveryAction}
          onClick={handleDeliveryClick}
          style={{ cursor: "pointer" }}
        >
          <Text level="p">Check for Express delivery </Text>
          <Image
            src={`${assetLoader()}/icons/Chevron_right.svg`}
            alt="arrow-right"
            width={20}
            height={20}
          />
        </div>
      )}
    </div>
  );
}
